import api from "@/lib/api";

export const marketingApi = {
  overview:        () => api.get("/marketing/overview").then((r) => r.data),
  leads:           (params = {}) => api.get("/marketing/leads", { params }).then((r) => r.data),
  leadsSummary:    () => api.get("/marketing/leads/summary").then((r) => r.data),
  sources:         () => api.get("/marketing/sources").then((r) => r.data),
  profitability:   () => api.get("/marketing/profitability").then((r) => r.data),
  integrations:    () => api.get("/marketing/integrations").then((r) => r.data),
  kpiLast30d:      () => api.get("/marketing/kpi/last30d").then((r) => r.data),
  editorialList:   (status) => api.get("/marketing/editorial", { params: status ? { status } : {} }).then((r) => r.data),
  editorialCreate: (body) => api.post("/marketing/editorial", body).then((r) => r.data),
  editorialPatch:  (id, body) => api.patch(`/marketing/editorial/${id}`, body).then((r) => r.data),
  editorialTransition: (id, body) => api.post(`/marketing/editorial/${id}/transition`, body).then((r) => r.data),
  editorialDelete: (id) => api.delete(`/marketing/editorial/${id}`).then((r) => r.data),
  aiAsk:           (body) => api.post("/marketing/ai/ask", body).then((r) => r.data),

  // Director de Marketing IA (chat + propose/approve/execute)
  director: {
    status:        () => api.get("/marketing/chat/status").then((r) => r.data),
    convCreate:    (body) => api.post("/marketing/chat/conversations", body).then((r) => r.data),
    convList:      () => api.get("/marketing/chat/conversations").then((r) => r.data),
    convGet:       (id) => api.get(`/marketing/chat/conversations/${id}`).then((r) => r.data),
    convDelete:    (id) => api.delete(`/marketing/chat/conversations/${id}`).then((r) => r.data),
    sendMessage:   (id, body) => api.post(`/marketing/chat/conversations/${id}/message`, body).then((r) => r.data),
    proposalsList: (params = {}) => api.get("/marketing/chat/proposals", { params }).then((r) => r.data),
    proposalGet:   (id) => api.get(`/marketing/chat/proposals/${id}`).then((r) => r.data),
    proposalApprove: (id, body) => api.post(`/marketing/chat/proposals/${id}/approve`, body).then((r) => r.data),
    proposalReject:  (id, body) => api.post(`/marketing/chat/proposals/${id}/reject`, body).then((r) => r.data),
    killSwitchGet: () => api.get("/marketing/chat/kill-switch").then((r) => r.data),
    killSwitchSet: (body) => api.post("/marketing/chat/kill-switch", body).then((r) => r.data),
    auditList:     (params = {}) => api.get("/marketing/chat/audit", { params }).then((r) => r.data),
    alertsList:    () => api.get("/marketing/chat/alerts").then((r) => r.data),
    alertDismiss:  (id) => api.post(`/marketing/chat/alerts/${id}/dismiss`).then((r) => r.data),
    limits:        () => api.get("/marketing/chat/limits").then((r) => r.data),
    tokenUsage:    (conversation_id) => api.get("/marketing/chat/token-usage", {
      params: conversation_id ? { conversation_id } : {},
    }).then((r) => r.data),
    tokenBudgetGet: () => api.get("/marketing/chat/token-budget").then((r) => r.data),
    tokenBudgetSet: (body) => api.put("/marketing/chat/token-budget", body).then((r) => r.data),
    tokenAlerts:   () => api.get("/marketing/chat/token-alerts").then((r) => r.data),
  },
};

export const fmtUsd = (n) => {
  if (n === null || n === undefined) return "—";
  const v = Number(n);
  if (!isFinite(v)) return "—";
  return v.toLocaleString("es-ES", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
};

export const fmtPct = (n) => {
  if (n === null || n === undefined) return "—";
  const v = Number(n);
  if (!isFinite(v)) return "—";
  return `${v.toFixed(1)}%`;
};

export const fmtInt = (n) => {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString("es-ES");
};
